var isCheckout = false;

$(function() {

  /*$("#product_featured_image").on("mousemove", function(e) {
    var imageOffset = $(this).offset(); 

    var mouseX = e.pageX - imageOffset.left;
    var mouseY = e.pageY - imageOffset.top;

    var handleLeft = mouseX - 120;
    var handleTop = mouseY - 150;

    if (handleLeft < 0) {
      handleLeft = 0;
    }
    else if (handleLeft > 478) {
      handleLeft = 478;
    }

    if (handleTop < 0) {
      handleTop = 0;
    }
    else if (handleTop > 598) {
      handleTop = 598;
    }

    $("#product_featured_image_zoom_handle").css({
      "left": handleLeft + "px",
      "top": handleTop + "px"
    }).show();

    $("#product_featured_image_zoom").css({
      "background-position": (handleLeft * -4) + "px " + (handleTop * -4) + "px"
    }).show();
  });

  $("#product_featured_image").on("mouseleave", function(e) {
    $("#product_featured_image_zoom_handle").hide();
    $("#product_featured_image_zoom").hide();
  });*/

  if ($("#product_thumbnails .product_image").length <= 3) {
    $("#product_thumbnails_up, #product_thumbnails_down").hide();
  }

  $("#product_thumbnails_up.clickable").on("click", function() {
    if ($(this).hasClass("clickable")) {
      $(this).removeClass("clickable");

      var img = $("#product_thumbnails .product_image:last-child").remove();
      $("#product_thumbnails")
          .prepend(img)
          .css({"top": "-200px"});

      $("#product_thumbnails").animate({
        "top": 0
      }, 1000, function() {
        $("#product_thumbnails_up").addClass("clickable");
      });
    }
  });

  $("#product_thumbnails_down.clickable").on("click", function() {
    if ($(this).hasClass("clickable")) {
      $(this).removeClass("clickable");

      $("#product_thumbnails").animate({
        "top": "-200px"
      }, 1000, function() {
        var img = $("#product_thumbnails .product_image:first-child").remove();
        $("#product_thumbnails")
          .append(img)
          .css({"top": 0});
        $("#product_thumbnails_down").addClass("clickable");
      });
    }
  });

  $("#product_thumbnails").on("click", ".product_image", function() {
    /*$("#product_featured_image, #product_featured_image_zoom").css({
      "background-image": $(this).css("background-image")
    });*/
    $("#product_featured_image").css({
      "background-image": $(this).css("background-image")
    });

    $("#full_size_images .current").removeClass("current");
    $($("#full_size_images .full_size_image").get($(this).index())).addClass("current");
  });



  if ($("#full_size_images .full_size_image").length < 2) {
    $("#full_size_images_prev, #full_size_images_next").hide();
  }

  $("#full_size_images .full_size_image:first").addClass("current");

  $("#product_featured_image, #product_view_full_size").on("click", function() {
    //$("#full_size_images .full_size_image").show();
    $("#full_size_images .current").show();
    $("#mask, #full_size_images").show();
  });

  $("#full_size_images_close").on("click", function() {
    $("#mask, #full_size_images").hide();
  });

  $("#full_size_images_prev").on("click", function() {
    var currentIndex = $("#full_size_images .current").index();
    $("#full_size_images .current").removeClass("current").hide();

    if (currentIndex > 0) {
      $($("#full_size_images .full_size_image").get(currentIndex - 1)).addClass("current").show();
    }
    else {
      $("#full_size_images .full_size_image").last().addClass("current").show();
    }
  });

  $("#full_size_images_next").on("click", function() {
    var currentIndex = $("#full_size_images .current").index();
    $("#full_size_images .current").removeClass("current").hide();

    if (currentIndex + 1 < $("#full_size_images .full_size_image").length) {
      $($("#full_size_images .full_size_image").get(currentIndex + 1)).addClass("current").show();
    }
    else {
      $("#full_size_images .full_size_image").first().addClass("current").show();
    }
  });



  /*Shopify.onItemAdded = function(line_item) {
    $("#mask, #add_product_success").show();
  };*/

  $("#add_product_success_close").on("click", function() {
    //$("#mask, #add_product_success").hide();
    location.reload();
  });

  $("#variant_quantity").on("keyup", function() {
    var quantity = $("#variant_quantity").val();
    quantity = quantity.replace(/\D/g, "");
    $("#variant_quantity").val(quantity);
  });

  $("#add_to_bag_form").on("submit", function() {
    /*$.post("/cart/add.js", {
      "id": $("#variant_id").val(),
      "quantity": $("#variant_quantity").val()
    }, function(response) {
      alert("x");
      Shopify.onItemAdded;
    });*/

    //Shopify.addItem($("#variant_id").val(), $("#variant_quantity").val());

    var giftEmail = "";
    var giftFirstName = "";
    var giftLastName = "";

    var isGiftCard = false;
    var isNoError = true;

    if ($("#gift_email").length && $("#gift_first_name").length && $("#gift_last_name").length) {
      isGiftCard = true;
      $("#gift_email, #gift_first_name, #gift_last_name").removeClass("error_input");

      giftEmail = $("#gift_email").val();
      giftFirstName = $("#gift_first_name").val();
      giftLastName = $("#gift_last_name").val();

      if (giftEmail == "") {
        $("#gift_email").addClass("error_input");
        isNoError = false;
      }
      if (giftFirstName == "") {
        $("#gift_first_name").addClass("error_input");
        isNoError = false;
      }
      if (giftLastName == "") {
        $("#gift_last_name").addClass("error_input");
        isNoError = false;
      }
    }

    var data = {}
    if (!isGiftCard) {
      data = {
        "id": $("#variant_id").val(),
        "quantity": $("#variant_quantity").val()
      }
    }
    else {
      data = {
        "id": $("#variant_id").val(),
        "quantity": $("#variant_quantity").val(),
        "properties[Gift Email]": giftEmail,
        "properties[Gift First Name]": giftFirstName,
        "properties[Gift Last Name]": giftLastName
      }
    }

    if (isNoError) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data
      }).done(function() {
        isCheckout ? location.href = "/cart": $("#mask, #add_product_success").show();
      });
    }

    return false;
  });

  $("#add_to_bag_button").on("click", function() {
    isCheckout = false;
  });

  $("#checkout_button").on("click", function() {
    isCheckout = true;
  });

  $("#product_discount").on("click", function() {
    showDiscountPopup();
  });
});
